import React from "react";

export default function TopBarIdentity({
  logoSrc,
  ville,
  pageMeta,
  onGoToDashboard,
}) {
  return (
    <div className="flex min-w-0 items-center gap-3 sm:gap-4">
      <button
        type="button"
        onClick={onGoToDashboard}
        className="hidden h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-slate-200 bg-white p-1.5 shadow-sm transition hover:scale-[1.02] hover:shadow-md sm:flex dark:border-slate-700 dark:bg-slate-900"
        title="Retour au tableau de bord"
      >
        <img
          src={logoSrc}
          alt={ville}
          className="h-full w-full object-contain"
        />
      </button>

      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="hidden h-2 w-2 rounded-full bg-emerald-500 sm:block" />

          <p className="truncate text-[10px] font-bold uppercase tracking-[0.24em] text-slate-400 dark:text-slate-500">
            Espace administrateur
          </p>
        </div>

        <h1 className="mt-0.5 truncate text-base font-bold text-slate-950 sm:text-xl dark:text-white">
          {pageMeta.label}
        </h1>

        <p className="hidden max-w-xl truncate text-xs text-slate-500 dark:text-slate-400 md:block">
          {ville} · {pageMeta.helper}
        </p>
      </div>
    </div>
  );
}